import { EditOutlined } from "@ant-design/icons";
import { Button, Checkbox, DatePicker, Form, Input, Modal, Popconfirm, Radio, Segmented, Select, Table, Tag, TimePicker } from "antd";
import Search from "antd/es/transfer/search";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { getAllOvertime, makeOverTimePayment, updateOvertime } from "../../redux/rtk/features/overtime/overtimeSlice";
import getPermissions from "../../utils/getPermissions";
import getUserFromToken from "../../utils/getUserFromToken";
import ViewBtn from "../Buttons/ViewBtn";
import BtnViewSvg from "../UI/Button/btnViewSvg";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import { GreenLinkBtn } from "../UI/AllLinkBtn";
import BtnAllSvg from "../UI/Button/btnAllSvg";
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs'; // Import exceljs for Excel generation
import { saveAs } from 'file-saver';
// import XLSXStyle from 'xlsx-style';

const { RangePicker } = DatePicker;

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Kolkata");

function OvertimeData() {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.overtime);
    const userId = getUserFromToken();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [form] = Form.useForm();
    const [searchText, setSearchText] = useState('');
    const [filteredList, setFilteredList] = useState([]);
    const [overtimeStart, setOvertimeStart] = useState({ date: null, time: null });
    const [overtimeEnd, setOvertimeEnd] = useState({ date: null, time: null });
    const [rewardType, setRewardType] = useState("Toil");
    const [payRate, setPayRate] = useState(null);
    const permissions = getPermissions();
    const [dateRange, setDateRange] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [columnsToShow, setColumnsToShow] = useState([]);
    const [approvalFilter, setApprovalFilter] = useState("ALL");
    const [paymentFilter, setPaymentFilter] = useState("ALL");
    const hasPermission = (item) => {
        return permissions?.includes(item ? item : "");
    };

    // const filteredData = list.filter((item) => item.user.reportingManagerId === userId);
    const filteredData = (list || []).filter(
        (item) => item?.user?.reportingManagerId === userId
    );



    const dataToShow = hasPermission("show-menu") ? filteredData : list;
    useEffect(() => {
        dispatch(getAllOvertime());
    }, [dispatch]);

    // useEffect(() => {
    //     if (list) {
    //         const filtered = list.filter(item => {
    //             const fullName = `${item.user?.firstName} ${item.user?.lastName}`.toLowerCase();
    //             return fullName.includes(searchText.toLowerCase());
    //         });
    //         setFilteredList(filtered);
    //     }
    // }, [list, searchText]);
    useEffect(() => {
        if (list) {
            const filtered = list.filter(item => {
                const fullName = `${item.user?.firstName} ${item.user?.lastName}`.toLowerCase();
                const nameMatch = fullName.includes(searchText.toLowerCase());

                // Apply date filtering if date range is selected
                let dateMatch = true;
                if (dateRange && dateRange[0] && dateRange[1]) {
                    const itemStartDate = dayjs(item.overtimeStart).utc();
                    const startDate = dateRange[0];
                    const endDate = dayjs(dateRange[1]).add(1, 'day');

                    dateMatch = (itemStartDate.isAfter(startDate.startOf('day')) ||
                        itemStartDate.isSame(startDate.startOf('day'))) &&
                        (itemStartDate.isBefore(endDate.endOf('day')) ||
                            itemStartDate.isSame(endDate.endOf('day')));
                }

                // Apply approval status filter
                const matchesApprovalFilter = approvalFilter === "APPROVED" ? item.approve === 1 :
                    approvalFilter === "REJECTED" ? item.approve === 0 :
                        approvalFilter === "PENDING" ? item.approve === null : true;

                // Apply payment status filter
                const matchesPaymentFilter = paymentFilter === "ALL" ||
                    (paymentFilter === "PAID" && item.paymentStatus === "PAID") ||
                    (paymentFilter === "UNPAID" && (!item.paymentStatus || item.paymentStatus === "UNPAID"));

                return nameMatch && dateMatch && matchesApprovalFilter && matchesPaymentFilter;
            });

            setFilteredList(filtered);
        }
    }, [list, searchText, dateRange, approvalFilter, paymentFilter]);

    const formatOvertimeLength = (length) => {
        const hours = Math.floor(length);
        const minutes = Math.round((length - hours) * 60);
        return `${hours}h ${minutes}m`;
    };
    const handleEdit = (record) => {
        setSelectedRecord(record);
        const startDateTime = dayjs(record.overtimeStart).utc();
        const endDateTime = dayjs(record.overtimeEnd).utc();

        setOvertimeStart({
            date: startDateTime.format('YYYY-MM-DD'),
            time: startDateTime.format('HH:mm')
        });

        setOvertimeEnd({
            date: endDateTime.format('YYYY-MM-DD'),
            time: endDateTime.format('HH:mm')
        });

        setRewardType(record.overtimeReward ? "Payable" : "Toil");
        setPayRate(record.payRate);

        form.setFieldsValue({
            note: record.note,
            payRate: record.payRate,
        });

        setIsModalVisible(true);
    };

    // const handleDelete = (id) => {
    //     dispatch(DeleteOvertime({ id, values: {} }))
    //         .unwrap()
    //         .then(() => {
    //             dispatch(loadAllOvertimeLog());
    //         })
    //         .catch((error) => {
    //             console.error("Delete failed:", error);
    //         });
    // };

    const handleCheckboxChange = (e, key) => {
        if (e.target.checked) {
            setSelectedRows((prev) => [...prev, key]);
        } else {
            setSelectedRows((prev) => prev.filter((item) => item !== key));
        }
    };

    const handleMakePayment = () => {
        if (selectedRows.length === 0) {
            return;
        }
        Promise.all(
            selectedRows.map((id) =>
                dispatch(makeOverTimePayment({ id, values: { paymentStatus: "PAID" } }))
            )
        )
            .then(() => {
                setSelectedRows([]);
                dispatch(getAllOvertime());
            })
            .catch((error) => {
                console.error("Payment failed", error);
            });
    };

    const columns = [
        // {
        //     title: "S.No",
        //     dataIndex: "serial",
        //     key: "serial",
        // },
        {
            id: 1,
            title: "S.No",
            dataIndex: "serial",
            key: "serial",
            render: (text, record) => (
                <div className="flex items-center">
                    {(!record.paymentStatus || record.paymentStatus === "UNPAID") && (
                        <Checkbox
                            className="mr-2"
                            onChange={(e) => handleCheckboxChange(e, record.key)}
                        />
                    )}
                    <span>{text}</span>
                </div>
            ),
        },
        {
            title: "Employee Name",
            dataIndex: "user",
            key: "user",
            render: (user) => `${user.firstName} ${user.lastName}`,
        },
        {
            title: "Overtime Start",
            dataIndex: "overtimeStart",
            key: "overtimeStart",
            render: (overtimeStart) => dayjs(overtimeStart).utc().format("DD-MM-YYYY, HH:mm A"),
        },
        {
            title: "Overtime End",
            dataIndex: "overtimeEnd",
            key: "overtimeEnd",
            render: (overtimeEnd) => dayjs(overtimeEnd).utc().format("DD-MM-YYYY, HH:mm A"),
        },
        {
            title: "Overtime Length",
            dataIndex: "overtimeLength",
            key: "overtimeLength",
            render: (overtimeLength) => formatOvertimeLength(overtimeLength),
        },
        {
            title: "Reward",
            dataIndex: "overtimeReward",
            key: "overtimeReward",
            render: (overtimeReward) => (overtimeReward ? "Payable" : "TOIL"),
        },

        {
            title: "Approval Status",
            dataIndex: "approve",
            key: "approve",
            render: (approve) => {
                let statusText;
                let color;

                if (approve === 1) {
                    statusText = "Accepted";
                    color = "green";
                } else if (approve === 0) {
                    statusText = "Rejected";
                    color = "red";
                } else {
                    statusText = "Pending";
                    color = "orange";
                }

                return <span style={{ color }}>{statusText}</span>;
            },
        },
        {
            title: "Note",
            dataIndex: "note",
            key: "note",
            render: (text) => {
                return text ? text : "No Remarks"
            }
        },
        //     {
        //         title: "Action",
        //         key: "action",
        //         render: ({ id }) => (
        //             <ViewBtn
        //                 path={`/admin/overtime/${id}`}
        //                 text='View'
        //                 icon={<BtnViewSvg />}
        //             />
        //         ),
        //     },
        // ];
        {
            id: 8,
            title: "Payment Status",
            dataIndex: "paymentStatus",
            key: "paymentStatus",
            render: (paymentStatus) => {
                if (paymentStatus === "PAID") {
                    return <Tag color='green'>{paymentStatus.toUpperCase()}</Tag>;
                } else {
                    return <Tag color='orange'>{(paymentStatus || "UNPAID").toUpperCase()}</Tag>;
                }
            },
        },
        {
            title: "Action",
            key: "action",
            render: (record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <ViewBtn
                        path={`/admin/overtime/${record.id}`}
                        text='View'
                        icon={<BtnViewSvg />}
                    />
                    <Button
                        type="primary"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record)}
                        size="small"
                    >
                        Edit
                    </Button>
                    {/* <Popconfirm
						title="Are you sure to delete this overtime log?"
						onConfirm={() => handleDelete(id)}
						okText="Yes"
						cancelText="No"
					>
						<Button danger>Delete</Button>
					</Popconfirm> */}
                </div>
            ),
        },
    ];

    const handleAction = (record) => {
        setSelectedRecord(record);
        form.setFieldsValue({
            user: `${record.user.firstName} ${record.user.lastName}`,
            overtimeHours: record.overtimeLength,
            overtimeStatus: record.status ? "Approved" : "Pending",
        });
        setIsModalVisible(true);
    };


    const handleModalCancel = () => {
        setIsModalVisible(false);
        setSelectedRecord(null);
        form.resetFields();
        setOvertimeStart({ date: null, time: null });
        setOvertimeEnd({ date: null, time: null });
        setRewardType("Toil");
        setPayRate(null);
    };

    const handleModalSubmit = async () => {
        try {
            const values = await form.validateFields();
            const formData = {
                ...values,
                overtimeStart: overtimeStart.date && overtimeStart.time
                    ? new Date(Date.UTC(
                        overtimeStart.date.split('-')[0],
                        overtimeStart.date.split('-')[1] - 1,
                        overtimeStart.date.split('-')[2],
                        ...overtimeStart.time.split(':').map(Number)
                    ))
                    : null,
                overtimeEnd: overtimeEnd.date && overtimeEnd.time
                    ? new Date(Date.UTC(
                        overtimeEnd.date.split('-')[0],
                        overtimeEnd.date.split('-')[1] - 1,
                        overtimeEnd.date.split('-')[2],
                        ...overtimeEnd.time.split(':').map(Number)
                    ))
                    : null,
                overtimeReward: rewardType === "Payable",
                payRate: rewardType === "Payable" ? payRate : null,
            };
            console.log('Sending update data:', formData);
            dispatch(updateOvertime({ id: selectedRecord.id, values: formData }))
                .then(() => {
                    handleModalCancel();
                    dispatch(getAllOvertime());
                });
        } catch (info) {
            console.error("Validation Failed:", info);
        }
    };

    const handleResetDateFilter = () => {
        setDateRange(null);
    };
    const onAllClick = () => {
        setApprovalFilter("ALL"); // Reset to default approval status
        setPaymentFilter("ALL"); // Reset payment filter
        setSearchText(""); // Reset search
        setDateRange(null); // Reset date range
    };

    const onApprovalFilterChange = (value) => {
        setApprovalFilter(value);
    };

    const onPaymentFilterChange = (value) => {
        setPaymentFilter(value);
    };

    const csvData = ((filteredList?.length > 0 ? filteredList : list) || []).map((item) => ({
        "Employee Name": `${item?.user?.firstName || ""} ${item?.user?.lastName || ""}`,
        "Start Date": item?.overtimeStart ? dayjs(item.overtimeStart).utc().format("DD-MM-YYYY, HH:mm A") : "N/A",
        "End Date": item?.overtimeEnd ? dayjs(item.overtimeEnd).utc().format("DD-MM-YYYY, HH:mm A") : "N/A",
        "Overtime Length": item?.overtimeLength ? formatOvertimeLength(item.overtimeLength) : "N/A",
        "Reward": item?.overtimeReward ? "Payable" : "TOIL",
        "Approval": item?.approve === 1 ? "Accepted" : item?.approve === 0 ? "Rejected" : "Pending",
        "Note": item?.note || "No Remarks",
        "Payment Status": item?.paymentStatus,
    }));

    // const exportToExcel = async () => {
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet('Overtime Details');
    
    //     // Hide gridlines
    //     worksheet.views = [{ state: 'frozen', ySplit: 1,showGridLines: false }];
    
    //     worksheet.columns = [
    //         { header: "S.No", key: "S.No", width: 10 },
    //         { header: "Employee Name", key: "Employee Name", width: 25 },
    //         { header: "Start Date", key: "Start Date", width: 25 },
    //         { header: "End Date", key: "End Date", width: 25 },
    //         { header: "Overtime Length", key: "Overtime Length", width: 15 },
    //         { header: "Reward", key: "Reward", width: 15 },
    //         { header: "Approval", key: "Approval", width: 15 },
    //         { header: "Note", key: "Note", width: 20 },
    //         { header: "Payment Status", key: "Payment Status", width: 15 },
    //     ];
    
    //     const data = ((filteredList?.length > 0 ? filteredList : list) || []).map((item, index) => ({
    //         "S.No": index + 1,
    //         "Employee Name": `${item?.user?.firstName || ""} ${item?.user?.lastName || ""}`,
    //         "Start Date": item?.overtimeStart ? dayjs(item.overtimeStart).utc().format("DD-MM-YYYY, HH:mm A") : "N/A",
    //         "End Date": item?.overtimeEnd ? dayjs(item.overtimeEnd).utc().format("DD-MM-YYYY, HH:mm A") : "N/A",
    //         "Overtime Length": item?.overtimeLength ? formatOvertimeLength(item.overtimeLength) : "N/A",
    //         "Reward": item?.overtimeReward ? "Payable" : "TOIL",
    //         "Approval": item?.approve === 1 ? "Accepted" : item?.approve === 0 ? "Rejected" : "Pending",
    //         "Note": item?.note || "No Remarks",
    //         "Payment Status": item?.paymentStatus || "UNPAID",
    //     }));
    
    //     worksheet.addRows(data);
    
    //     const headerRow = worksheet.getRow(1);
    //     headerRow.eachCell({ includeEmpty: false }, (cell) => {
    //         cell.font = { color: { argb: 'FFFFFFFF' }, bold: true, size: 12 };
    //         cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    //         cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F497D' } };
    //         cell.border = {
    //             top: { style: 'thick', color: { argb: 'FF000000' } },
    //             left: { style: 'thick', color: { argb: 'FF000000' } },
    //             bottom: { style: 'thick', color: { argb: 'FF000000' } },
    //             right: { style: 'thick', color: { argb: 'FF000000' } },
    //         };
    //     });
    //     // headerRow.height = 25;
    
    //     worksheet.eachRow((row, rowNumber) => {
    //         row.eachCell({ includeEmpty: true }, (cell) => {
    //             cell.border = {
    //                 top: { style: 'thin', color: { argb: 'FF000000' } },
    //                 left: { style: 'thin', color: { argb: 'FF000000' } },
    //                 bottom: { style: 'thin', color: { argb: 'FF000000' } },
    //                 right: { style: 'thin', color: { argb: 'FF000000' } },
    //             };
    //             cell.alignment = { vertical: 'middle', horizontal: 'center',  wrapText: true };
    //         });
    
    //         if (rowNumber > 1) {
    //             row.eachCell({ includeEmpty: true }, (cell) => {
    //                 cell.fill = {
    //                     type: 'pattern',
    //                     pattern: 'solid',
    //                     fgColor: { argb: rowNumber % 2 === 0 ? 'FFEFEFEF' : 'FFFFFFFF' },
    //                 };
    //             });
    //         }

    //     });
        
    //     // worksheet.eachRow((row) => {
    //     //     row.height = 20;
    //     // });
    
    //     worksheet.pageSetup = {
    //         paperSize: 9,
    //         orientation: 'portrait',
    //         fitToPage: true,
    //         fitToWidth: 1,
    //         fitToHeight: 0,
    //     };
    
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //     saveAs(blob, 'overtime_details.xlsx');
    // };
    
    
    // const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

    const addKeys = (arr = []) => arr.map((i, index) => ({
        ...i,
        key: i?.id || index,
        serial: index + 1
    }));


    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                }}
            >
                <h2 style={{ fontSize: "20px", fontWeight: "bold" }}>Overtime Log</h2>
                {list && (
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <CsvLinkBtn>
                            <CSVLink
                                data={csvData}
                                className='btn btn-dark btn-sm'
                                style={{ marginTop: "5px" }}
                                filename='overtime_details'>
                                Download CSV
                            </CSVLink>
                        </CsvLinkBtn>
                        {/* <Button className="btn btn-dark btn-sm" onClick={exportToExcel}>
                            Download Excel
                        </Button> */}

                        <GreenLinkBtn>
                            <button onClick={onAllClick}>
                                <BtnAllSvg size={15} title={"ALL"} />
                            </button>
                        </GreenLinkBtn>

                        <Segmented
                            className='text-center rounded'
                            size='middle'
                            defaultValue={"APPROVED"}
                            options={[
                                {
                                    label: (
                                        <span className='text-green-500'>
                                            Accepted
                                        </span>
                                    ),
                                    value: "APPROVED",
                                },
                                {
                                    label: (
                                        <span className='text-red-500'>
                                            Rejected
                                        </span>
                                    ),
                                    value: "REJECTED",
                                },
                                {
                                    label: (
                                        <span className='text-orange-500'>
                                            Pending
                                        </span>
                                    ),
                                    value: "PENDING",
                                },
                            ]}
                            value={approvalFilter}
                            onChange={onApprovalFilterChange}
                        />

                        <Segmented
                            className='text-center rounded'
                            size='middle'
                            defaultValue={"ALL"}
                            options={[
                                {
                                    label: (
                                        <span className='text-green-500'>
                                            Paid
                                        </span>
                                    ),
                                    value: "PAID",
                                },
                                {
                                    label: (
                                        <span className='text-orange-500'>
                                            Unpaid
                                        </span>
                                    ),
                                    value: "UNPAID",
                                },
                            ]}
                            value={paymentFilter}
                            onChange={onPaymentFilterChange}
                        />
                    </div>
                )}
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                }}
            >
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <Search
                        placeholder="Search by name..."
                        allowClear
                        size="large"
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ maxWidth: '400px' }}
                    />
                    <Popconfirm
                        title="Do you want to make payment for selected entries?"
                        onConfirm={handleMakePayment}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="primary" disabled={selectedRows.length === 0}>Make Payment</Button>
                    </Popconfirm>
                </div>

                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <RangePicker
                        value={dateRange}
                        onChange={(dates) => setDateRange(dates)}
                        style={{ width: '400px' }}
                        format="DD-MM-YYYY"
                        allowClear={true}
                        placeholder={['Start Date', 'End Date']}
                    />
                    {dateRange && (
                        <Button type="link" onClick={handleResetDateFilter}>
                            Clear Filters
                        </Button>
                    )}
                </div>
            </div>

            <Table
                columns={columns}
                dataSource={addKeys(searchText || dateRange || approvalFilter || paymentFilter ? filteredList : dataToShow)}
                loading={loading}
                rowKey="id"
            />
            <Modal
                title="Edit Overtime"
                visible={isModalVisible}
                onCancel={handleModalCancel}
                footer={[
                    <Button key="cancel" onClick={handleModalCancel}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleModalSubmit}>
                        Update
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Overtime Start"
                        required
                    >
                        <div className="flex justify-between">
                            <DatePicker
                                format="YYYY-MM-DD"
                                value={overtimeStart.date ? dayjs(overtimeStart.date) : null}
                                onChange={(date, dateString) =>
                                    setOvertimeStart({ ...overtimeStart, date: dateString })
                                }
                            />
                            <TimePicker
                                format="HH:mm"
                                value={overtimeStart.time ? dayjs(overtimeStart.time, 'HH:mm') : null}
                                onChange={(time, timeString) =>
                                    setOvertimeStart({ ...overtimeStart, time: timeString })
                                }
                            />
                        </div>
                    </Form.Item>

                    <Form.Item
                        label="Overtime End"
                        required
                    >
                        <div className="flex justify-between">
                            <DatePicker
                                format="YYYY-MM-DD"
                                value={overtimeEnd.date ? dayjs(overtimeEnd.date) : null}
                                onChange={(date, dateString) =>
                                    setOvertimeEnd({ ...overtimeEnd, date: dateString })
                                }
                            />
                            <TimePicker
                                format="HH:mm"
                                value={overtimeEnd.time ? dayjs(overtimeEnd.time, 'HH:mm') : null}
                                onChange={(time, timeString) =>
                                    setOvertimeEnd({ ...overtimeEnd, time: timeString })
                                }
                            />
                        </div>
                    </Form.Item>

                    <Form.Item label="Reward">
                        <Radio.Group
                            onChange={(e) => setRewardType(e.target.value)}
                            value={rewardType}
                        >
                            <Radio.Button value="Toil">Toil</Radio.Button>
                            <Radio.Button value="Payable">Payable</Radio.Button>
                        </Radio.Group>
                    </Form.Item>

                    {rewardType === "Payable" && (
                        <Form.Item
                            label="Pay Rate"
                            name="payRate"
                        >
                            <Select
                                value={payRate}
                                onChange={setPayRate}
                                placeholder="Select Pay Rate"
                            >
                                <Select.Option value="1.0">1.0 (Standard Rate)</Select.Option>
                                <Select.Option value="1.25">1.25 (Time & Quarter)</Select.Option>
                                <Select.Option value="1.33">1.33 (Time & Third)</Select.Option>
                                <Select.Option value="1.5">1.5 (Time & Half)</Select.Option>
                                <Select.Option value="2.0">2.0 (Double Time)</Select.Option>
                                <Select.Option value="3.0">3.0 (Triple Time)</Select.Option>
                            </Select>
                        </Form.Item>
                    )}

                    <Form.Item
                        label="Notes"
                        name="note"
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default OvertimeData;
